import React from 'react';
import { Stack, Pagination, Typography } from '@mui/material';

/**
 * Shared pager for the admin list tabs.
 *
 *   - `page` is 1-based to match MUI's `Pagination` component.
 *   - `pageSize` rows per page (constant per tab, no UI for now).
 *   - `total` from the server. When unknown (0), the pager hides.
 *
 * Callers translate `(page, pageSize)` into `skip = (page-1) * pageSize`.
 */
export default function AdminTableFooter({ page, pageSize, total, onChange, label = 'rows' }) {
  if (!total || total <= pageSize) {
    return (
      <Typography variant='caption' color='text.secondary' display='block' mt='12px' textAlign='right'>
        {total ? `${total} ${label}` : ''}
      </Typography>
    );
  }
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      mt='14px'
      flexWrap='wrap'
      gap='8px'
    >
      <Typography variant='caption' color='text.secondary'>
        Showing {from}–{to} of {total} {label}
      </Typography>
      <Pagination
        size='small'
        count={pageCount}
        page={page}
        onChange={(_e, p) => onChange(p)}
        showFirstButton
        showLastButton
      />
    </Stack>
  );
}
